// @ts-nocheck
// Planner entries outside the planner (vhp-planner docs/entry.md).
// - Goal chips (snippets/vhp-plan-goal.liquid, Explore): a tap keeps the goal for the planner, which then opens past
//   the goal screen (assets/vhp-planner-funnel.js, 'vhp_planner_goal').
// - The planner explainer (snippets/vhp-plan-explainer.liquid) for anyone who hasn't started the planner: what it is,
//   why, what happens next, then "Kostenlose Wochenvorschau". Opened by [data-vhp-plan-cta]: the card under recipes' method
//   (end; the recipe's top CTA "Mein Proteinziel berechnen" goes straight in), the top-bar "Planer" (topbar) and the side menu (sidepanel);
//   and from code by "Zum Meal Plan hinzufügen" / the swipe card's calendar button (assets/vhp-recipe-sheet.js:
//   card, sheet, cook, page), where it takes the soft paywall's place. A dish that comes along is saved as a like
//   right away (shown in the sheet) and named first in the planner when they continue (vhp_planner_pick).
//   Someone who has started (goal picked, preview waiting) goes straight in, or gets the soft paywall.
// planner_cta_click with the source comes from data-track (assets/vhp-track.js); it decides the planner_entry.
// - The portion calculator on recipes (snippets/vhp-portion-calc.liquid, window.vhpPortionCalc), see below.
(() => {
  'use strict';

  if (window.vhpPlanGoal) return;
  window.vhpPlanGoal = true;

  // ---------- portion calculator (2026-10-17; reworked 2026-10-18 as an app-style flow, docs/HOMEPAGE_FUNNEL.md) ----------
  // One question per step: their goal (a tap moves on), then sex and weight / height / age as sliders (no keyboard over
  // the sheet; they start neutral and never move by themselves), then their portion of this recipe as plates and two
  // numbers, one row with the day it is calculated for ("Gerechnet für 4 Mahlzeiten am Tag") that opens six day
  // patterns, and the way into the planner. The planner's own numbers: Mifflin-St Jeor × light activity ± goal (Abnehmen:
  // its LOSE deficit, never under the basal rate), 1,200 to
  // 5,000 kcal, protein 30 % of kcal (assets/vhp-planner-funnel.js computeKcal, macroGrams), its meal split (mealShares,
  // Einstellungen > Mahlzeiten; the first four patterns are its MEAL_PRESETS) and the portion its fitPortion picks at the
  // meal's share under its share cap (assets/vhp-planner-core.js shareCapFor). Keep in sync.
  // Body answers stay for this visit (sessionStorage CALC_KEY) and ride along to the planner (vhp_planner_goal), which
  // then skips what was answered; the derived day target stays TARGET_DAYS (TARGET_KEY) for "Für dich" on swipe cards.
  // A day pattern is written into the planner's saved state (mealShares + slots), so the plan follows it, until the
  // planner has a preview. GA / Shopify events: recipe_calc { step goal | result | meals, goal, where, preset }.
  const CALC_KEY = 'vhp_portion_calc';
  const CALC_LIMITS = { weight: [40, 200], height: [120, 220], age: [18, 80] };
  // Where the sliders start: the same neutral values for everyone.
  const CALC_START = { weight: 70, height: 170, age: 30 };
  // One tap to a portion (2026-10-26, RECIPE_FUNNEL.md 2.3): the goal tap shows the result for the typical visitor (vegan
  // women around 30, vhp-planner docs/features.md), named under the result with "Anpassen". Stored with assumed: true;
  // the planner then asks the body slide with these values filled in instead of skipping it.
  // Since 2026-10-29 (Maxim: no portion without knowing anything about her) the goal tap asks her weight first, the
  // biggest driver of the day's kcal; only sex, height and age stay assumed (weighed: true).
  const CALC_ASSUMED = { sex: 'female', weight: 65, height: 166, age: 30 };
  // lose: the planner's body-scaled deficit (LOSE, its computeKcal), not a flat delta.
  const GOAL_DELTA = { lose: 0, maintain: 0, gain: 300 };
  // The calculator's fourth tile "Einfach gut essen" (2026-11-01): maintain, stored and planned as maintain.
  const goalOf = (goal) => (goal === 'easy' ? 'maintain' : goal);
  const LOSE = { perKg: 5.5, share: 0.2, softShare: 0.1, max: 500, bmiHold: 18.5, bmiSoft: 22 };
  const PAL_LIGHT = 1.375;
  const QUARTER = { 0.25: '¼', 0.5: '½', 0.75: '¾' };
  const MEAL_IDS = ['breakfast', 'lunch', 'dinner', 'snack'];
  // Day patterns in whole percent of the day's kcal (the planner's normalizeMealShares rules: sum 100, at least 5 % per
  // meal, two meals, lunch or dinner). The first four are the planner's own presets.
  const MEAL_PRESETS = {
    balanced: { breakfast: 25, lunch: 35, dinner: 30, snack: 10 },
    small_breakfast: { breakfast: 15, lunch: 40, dinner: 35, snack: 10 },
    no_breakfast: { breakfast: 0, lunch: 50, dinner: 40, snack: 10 },
    big_breakfast: { breakfast: 35, lunch: 30, dinner: 25, snack: 10 },
    big_dinner: { breakfast: 20, lunch: 30, dinner: 40, snack: 10 },
    no_dinner: { breakfast: 30, lunch: 55, dinner: 0, snack: 15 },
  };
  const PRESET_KEY = 'vhp_meal_preset';
  const STORE_KEY = () => window.vhpPlannerLikes?.STORAGE_KEY || 'vhp_planner_anon';

  const readJson = (store, key) => {
    try {
      return JSON.parse(store.getItem(key) || 'null');
    } catch (e) {
      return null;
    }
  };
  const inRange = (key, value) => value >= CALC_LIMITS[key][0] && value <= CALC_LIMITS[key][1];
  const validBody = (b) =>
    Boolean(b && Object.prototype.hasOwnProperty.call(GOAL_DELTA, b.goal) && (b.sex === 'female' || b.sex === 'male') && inRange('weight', b.weight) && inRange('height', b.height) && inRange('age', b.age));

  // The planner's activity levels (assets/vhp-planner-funnel.js PAL); without an answer the light one, as before.
  const PAL = { sedentary: 1.2, light: 1.375, active: 1.55, very: 1.725 };
  const dayOf = (b) => {
    const bmr = 10 * b.weight + 6.25 * b.height - 5 * b.age + (b.sex === 'male' ? 5 : -161);
    const need = Math.round((bmr * (PAL[b.activity] || PAL_LIGHT)) / 10) * 10;
    let goalKcal = Math.round((need + GOAL_DELTA[b.goal]) / 10) * 10;
    if (b.goal === 'lose') {
      const bmi = b.weight / (b.height / 100) ** 2;
      const share = bmi < LOSE.bmiSoft ? LOSE.softShare : LOSE.share;
      const deficit = bmi < LOSE.bmiHold ? 0 : Math.min(LOSE.perKg * b.weight, share * need, LOSE.max);
      goalKcal = Math.max(Math.round((need - deficit) / 10) * 10, Math.ceil(bmr / 10) * 10);
    }
    const kcal = Math.min(5000, Math.max(1200, goalKcal));
    return { kcal, protein: Math.round((kcal * 30) / 100 / 4) };
  };
  const plannerDoc = () => readJson(localStorage, STORE_KEY()) || {};
  // A planner that built a preview: its target and protein split are the numbers (not the defaults of a half setup).
  const plannerDay = () => {
    const doc = plannerDoc();
    const kcal = Number(doc?.kcal) || 0;
    if (!doc?.preview || !kcal) return null;
    const pct = Number(doc.macros?.protein) || 30;
    return { kcal, protein: Math.round((kcal * pct) / 100 / 4) };
  };

  // "Für dich" (2026-10-18): the calculator's day target stays on the device for TARGET_DAYS (goal, kcal, protein:
  // derived numbers, never the body inputs, which stay with the visit in CALC_KEY), so swipe cards, sheets and recipe
  // pages show their portion on later visits too.
  const TARGET_KEY = 'vhp_portion_target';
  const TARGET_DAYS = 60;
  const storedDay = () => {
    const t = readJson(localStorage, TARGET_KEY);
    const kcal = Number(t?.kcal) || 0;
    if (!kcal || !(Date.now() - Date.parse(t.at || '') < TARGET_DAYS * 86400000)) return null;
    return { kcal, protein: Number(t.protein) || Math.round((kcal * 30) / 100 / 4), goal: GOAL_DELTA[t.goal] != null ? t.goal : '' };
  };
  const keepTarget = (goal, day) => {
    try {
      localStorage.setItem(TARGET_KEY, JSON.stringify({ goal, kcal: day.kcal, protein: day.protein, at: new Date().toISOString() }));
    } catch (e) {
      /* no storage: this visit only */
    }
    document.dispatchEvent(new CustomEvent('vhp:portion-target'));
  };
  // The day their portions are worked out for: the planner's own (a built preview), this visit's calculator answers,
  // the remembered target; null = not known yet.
  const targetDay = () => {
    const planned = plannerDay();
    if (planned) return planned;
    const saved = readJson(sessionStorage, CALC_KEY);
    return validBody(saved) ? dayOf(saved) : storedDay();
  };

  // ---- day pattern ----
  const plannerShares = () => {
    const shares = plannerDoc().mealShares;
    if (!shares || typeof shares !== 'object') return null;
    const on = MEAL_IDS.filter((id) => Number(shares[id]) > 0);
    const sum = on.reduce((s, id) => s + Number(shares[id]), 0);
    return sum === 100 && on.length >= 2 ? Object.fromEntries(MEAL_IDS.map((id) => [id, Number(shares[id]) || 0])) : null;
  };
  const presetOf = (shares) =>
    (shares && Object.keys(MEAL_PRESETS).find((id) => MEAL_IDS.every((m) => MEAL_PRESETS[id][m] === shares[m]))) || '';
  // Their pattern: the planner's split when it has one ('' = its own split, no pattern), else the calculator's, else
  // balanced.
  const savedPreset = () => {
    const shares = plannerShares();
    if (shares) return presetOf(shares);
    const id = localStorage.getItem(PRESET_KEY);
    return MEAL_PRESETS[id] ? id : 'balanced';
  };
  const currentShares = () => plannerShares() || MEAL_PRESETS[savedPreset()] || MEAL_PRESETS.balanced;
  const keepPreset = (id) => {
    const shares = MEAL_PRESETS[id];
    if (!shares) return;
    try {
      localStorage.setItem(PRESET_KEY, id);
    } catch (e) {
      /* this visit only */
    }
    // Into the planner's saved state, as its Mahlzeiten screen stores it (setMealShares): the plan follows it.
    window.vhpPlannerLikes?.patch(
      (raw) => {
        raw.mealShares = { ...shares };
        raw.slots = [...(shares.breakfast ? ['breakfast'] : []), 'main', ...(shares.snack ? ['snack'] : [])];
      },
      { silent: true }
    );
    document.dispatchEvent(new CustomEvent('vhp:portion-target'));
  };
  // The meal a recipe of this slot fills: breakfast, the bigger of lunch and dinner for mains, the snack otherwise.
  const mealFor = (slot, shares) => {
    if (slot === 'breakfast' && shares.breakfast > 0) return 'breakfast';
    if (slot === 'snack' || slot === 'dessert') return 'snack';
    return shares.dinner > shares.lunch ? 'dinner' : 'lunch';
  };
  // The planner's single-meal cap (vhp-planner-core.js shareCapFor): 40 %, 55 % once a meal is over 40 %.
  const shareCap = (shares) => {
    const max = Math.max(...MEAL_IDS.map((id) => shares[id] / 100));
    const cap = max > 0.4 + 1e-9 ? 0.55 : 0.4;
    return max > cap ? Math.min(1, max + 0.05) : cap;
  };

  // ½ to 2 portions in quarters, under the cap, nearest to the meal's share (the funnel's fitPortion).
  const fitPortion = (kcal, ideal, target, cap = 0.4) => {
    const limit = Math.floor(target * cap);
    let best = null;
    let bestDiff = Infinity;
    for (let step = 0; step <= 6; step += 1) {
      const scale = (2 + step) / 4;
      const shown = Math.round(kcal * scale);
      if (shown > limit) continue;
      const diff = Math.abs(shown - ideal);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = scale;
      }
    }
    return best;
  };

  const lang = () => document.documentElement.lang || 'de';
  const fmt = (n) => Math.round(n).toLocaleString(lang());
  const qty = (scale) => {
    const whole = Math.floor(scale + 1e-9);
    const frac = Math.round((scale - whole) * 4) / 4;
    return `${whole || ''}${QUARTER[frac] || ''}` || '0';
  };
  const fill = (template, vars) => String(template || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
  const cap1 = (id) => id.replace(/(^|_)(\w)/g, (m, sep, c) => c.toUpperCase());

  // Their portion of a dish ({ kcal, protein, slot }) for the known day and day pattern; null without a day.
  // `forced`: the meal she picked for this dish (the Für-dich step, batch 3); otherwise the slot decides.
  const portionOf = (dish, day = targetDay(), shares = currentShares(), forced = '') => {
    const kcal = Number(dish?.kcal) || 0;
    if (!day || !kcal) return null;
    const meal = MEAL_IDS.includes(forced) ? forced : mealFor(dish.slot, shares);
    const share = (shares[meal] || MEAL_PRESETS.balanced.snack) / 100;
    const fitted = fitPortion(kcal, Math.round(day.kcal * share), day.kcal, shareCap(shares));
    const scale = fitted || 0.5;
    const kcalN = kcal * scale;
    const proteinN = (Number(dish.protein) || 0) * scale;
    return { scale, fits: Boolean(fitted), meal, amount: qty(scale), kcal: fmt(kcalN), protein: fmt(proteinN), kcalN, proteinN };
  };

  // ---- motion: steps glide to their new height, numbers count, nothing moves with reduced motion ----
  const reduced = () => {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  };
  const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  const glide = (root, change) => {
    const before = root.getBoundingClientRect().height;
    change();
    if (reduced() || !before || typeof root.animate !== 'function') return;
    const after = root.getBoundingClientRect().height;
    if (Math.abs(after - before) < 2) return;
    root.style.overflow = 'hidden';
    const anim = root.animate([{ height: `${before}px` }, { height: `${after}px` }], { duration: 340, easing: EASE });
    const done = () => {
      root.style.overflow = '';
    };
    anim.onfinish = done;
    anim.oncancel = done;
    // A tab that draws no frames never finishes it: let go of the height anyway.
    window.setTimeout(() => anim.playState !== 'finished' && anim.cancel(), 600);
  };
  // Counts a number from what it showed to its new value (from 0 the first time), formatted, with a unit.
  const countTo = (el, to, unit = '') => {
    if (!el) return;
    const target = Math.round(to);
    const from = Number(el.dataset.n) || 0;
    el.dataset.n = String(target);
    const put = (value) => {
      el.textContent = `${fmt(value)}${unit}`;
    };
    if (reduced() || from === target) {
      put(target);
      return;
    }
    const start = performance.now();
    const duration = 620;
    const frame = (now) => {
      if (el.dataset.n !== String(target)) return;
      const t = Math.min(1, (now - start) / duration);
      put(from + (target - from) * (1 - (1 - t) ** 3));
      if (t < 1) requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
    // A background tab may not draw frames: the end value lands anyway.
    window.setTimeout(() => el.dataset.n === String(target) && put(target), duration + 150);
  };
  const replay = (el, cls) => {
    if (!el || reduced()) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  };

  // Plates: one per started portion, the food filled in quarters (1¼ = a full plate and a quarter).
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const svgEl = (name, attrs) => {
    const node = document.createElementNS(SVG_NS, name);
    Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, String(value)));
    return node;
  };
  const plate = (part) => {
    const svg = svgEl('svg', { viewBox: '0 0 52 52' });
    svg.append(svgEl('circle', { cx: 26, cy: 26, r: 25, class: 'vhp-calc__rim' }), svgEl('circle', { cx: 26, cy: 26, r: 18, class: 'vhp-calc__well' }));
    if (part >= 1) svg.append(svgEl('circle', { cx: 26, cy: 26, r: 18, class: 'vhp-calc__food' }));
    else if (part > 0) {
      const a = part * 2 * Math.PI;
      const x = (26 + 18 * Math.sin(a)).toFixed(2);
      const y = (26 - 18 * Math.cos(a)).toFixed(2);
      svg.append(svgEl('path', { d: `M26 26 L26 8 A18 18 0 ${a > Math.PI ? 1 : 0} 1 ${x} ${y} Z`, class: 'vhp-calc__food' }));
    }
    return svg;
  };
  const paintPlates = (box, scale) => {
    if (!box) return;
    const n = Math.max(1, Math.ceil(scale - 1e-9));
    box.replaceChildren(...Array.from({ length: n }, (_, i) => plate(Math.min(1, scale - i))));
  };

  const STEPS = {
    ask: 'data-vhp-calc-ask',
    weight: 'data-vhp-calc-weight',
    form: 'data-vhp-calc-form',
    activity: 'data-vhp-calc-activity',
    done: 'data-vhp-calc-done',
    result: 'data-vhp-calc-result',
    tune: 'data-vhp-calc-tune',
    meals: 'data-vhp-calc-meals',
  };
  const ORDER = ['ask', 'weight', 'form', 'activity', 'done', 'result', 'tune', 'meals'];
  const calcView = (root, view) => {
    const before = root.dataset.view;
    glide(root, () => {
      Object.entries(STEPS).forEach(([key, attr]) => {
        const step = root.querySelector(`[${attr}]`);
        if (!step) return;
        step.hidden = key !== view;
        step.classList.remove('is-in', 'is-back');
        if (key === view && before && before !== view && !reduced()) {
          void step.offsetWidth;
          step.classList.add(ORDER.indexOf(view) < ORDER.indexOf(before) ? 'is-back' : 'is-in');
        }
      });
      root.dataset.view = view;
    });
    // Cook mode: while she answers (or tunes) her row stays on screen above the card (assets/vhp-plan-goal.css).
    const strip = root.dataset.flow === '1' ? root.closest('[data-vhp-strip]') : null;
    if (strip) strip.classList.toggle('is-asking', !root.hidden && ASKING.has(view));
  };
  const ASKING = new Set(['ask', 'weight', 'form', 'activity', 'tune']);

  const pressOnly = (root, attr, value, aria = 'aria-pressed') => {
    root.querySelectorAll(`[${attr}]`).forEach((btn) => btn.setAttribute(aria, btn.getAttribute(attr) === value ? 'true' : 'false'));
  };
  // Segmented control: the white pill slides under the picked option.
  const paintSeg = (seg) => {
    if (!seg) return;
    const options = Array.from(seg.querySelectorAll('[role="radio"]'));
    const index = options.findIndex((btn) => btn.getAttribute('aria-checked') === 'true');
    seg.style.setProperty('--seg-n', String(options.length));
    if (index >= 0) seg.style.setProperty('--seg-i', String(index));
    seg.classList.toggle('has-pick', index >= 0);
  };

  // The row under the numbers: which day the portion is worked out for, and that it can change.
  const paintMealsRow = (root, shares) => {
    const d = root.dataset;
    const preset = presetOf(shares);
    const on = MEAL_IDS.filter((id) => shares[id] > 0);
    // Two rows since batch 3 (the result step and the Für-dich step): both say the same.
    root.querySelectorAll('[data-vhp-calc-meals-title]').forEach((title) => (title.textContent = fill(d.tRowTitle, { n: on.length })));
    root.querySelectorAll('[data-vhp-calc-meals-sub]').forEach((sub) => {
      sub.textContent = preset === 'balanced' ? d.tRowSub : fill(d.tRowChange, { preset: preset ? d[`tPreset${cap1(preset)}`] : d.tCustom });
    });
    root.querySelectorAll('[data-vhp-calc-icons] [data-meal]').forEach((icon) => icon.classList.toggle('is-off', !(shares[icon.dataset.meal] > 0)));
  };

  const paintResult = (root, day, started, opts = {}) => {
    const d = root.dataset;
    const shares = currentShares();
    const p = portionOf({ kcal: d.kcal, protein: d.protein, slot: d.slot }, day, shares, d.meal || '');
    if (!p) return;
    const showing = root.dataset.view === 'result';
    root._day = day;
    root._lastMeal = p.meal;
    // Batch 3: the live line of the Für-dich step, and the strip's pill (goal · weight · meal).
    const live = root.querySelector('[data-vhp-calc-live]');
    if (live && d.tLive) live.textContent = fill(d.tLive, { amount: fill(p.scale <= 1 ? d.tOne : d.tOther, { n: p.amount }), kcal: fmt(p.kcalN), protein: fmt(p.proteinN) });
    const pillWrap = root.closest('[data-vhp-recipe-body]')?.querySelector('[data-vhp-strip-pill-wrap]');
    const pill = pillWrap?.querySelector('[data-vhp-strip-pill]');
    if (pill && portionFirst(pillWrap.closest('[data-vhp-recipe-body]'))) {
      const b = readJson(sessionStorage, CALC_KEY);
      const goal = (validBody(b) && b.goal) || d.goal || storedDay()?.goal || 'lose';
      const weight = (validBody(b) && b.weight) || CALC_ASSUMED.weight;
      pill.textContent = fill(pill.dataset.tPill, { goal: pill.dataset[`tGoal${cap1(goal)}`] || goal, weight, meal: pill.dataset[`tMeal${cap1(p.meal)}`] || p.meal });
      const pHost = pillWrap.closest('[data-vhp-recipe-body]');
      pillWrap.hidden = Boolean(started) || (cookMode(pHost) && !inTiles(pHost));
    }
    paintPlates(root.querySelector('[data-vhp-calc-plates]'), p.scale);
    root.querySelector('[data-vhp-calc-amount]').textContent = fill(p.scale <= 1 ? d.tOne : d.tOther, { n: p.amount });
    root.querySelector('[data-vhp-calc-for]').textContent = d[`tFor${cap1(p.meal)}`] || '';
    const kcalEl = root.querySelector('[data-vhp-calc-kcal]');
    const proteinEl = root.querySelector('[data-vhp-calc-protein]');
    // A fresh result counts up from 0; a changed day pattern counts from the old numbers.
    if (!showing && !root._fromMeals) {
      kcalEl.dataset.n = '0';
      proteinEl.dataset.n = '0';
    }
    root._fromMeals = false;
    countTo(kcalEl, p.kcalN);
    countTo(proteinEl, p.proteinN, ' g');
    const big = root.querySelector('[data-vhp-calc-big]');
    if (big) {
      big.hidden = p.fits;
      big.textContent = d.tBig;
    }
    // The pot (RECIPE_FUNNEL.md 2.1): how many of their meals the recipe's portions make, from 2 on.
    const pot = root.querySelector('[data-vhp-calc-pot]');
    if (pot) {
      const portions = Number(d.portions) || 0;
      const meals = p.scale > 0 ? Math.floor(portions / p.scale) : 0;
      pot.hidden = !(portions >= 2 && meals >= 2 && d.tPot);
      if (!pot.hidden) pot.textContent = fill(d.tPot, { portions, n: meals });
    }
    // 2026-11-01 (Maxim): the result is one glance, a ring with the share of today's protein this plate covers and
    // "Die anderen 67 % plan ich dir". No day kcal: she does not want to count.
    const cover = root.querySelector('[data-vhp-calc-cover]');
    if (cover) {
      const pp = Number(day.protein) > 0 ? Math.round((Number(p.proteinN) / Number(day.protein)) * 100) : 0;
      const shown = Math.max(0, Math.min(100, pp));
      cover.hidden = pp <= 0;
      cover.querySelector('[data-vhp-calc-cover-pct]').textContent = `${shown} %`;
      cover.querySelector('[data-vhp-calc-cover-ring]').style.strokeDasharray = `${shown} 100`;
      cover.querySelector('[data-vhp-calc-cover-rest]').textContent =
        shown >= 100 ? cover.dataset.tFull || '' : fill(cover.dataset.tRest, { rest: 100 - shown });
    }
    // Started planners change their meals in the planner (Einstellungen > Mahlzeiten): their week is already planned.
    const meals = root.querySelector('[data-vhp-calc-meals-open]');
    if (meals) meals.hidden = started;
    if (!started) paintMealsRow(root, shares);
    const plan = root.querySelector('[data-vhp-calc-plan]');
    if (plan) plan.textContent = started ? d.tStarted : d.tPlan;
    const note = root.querySelector('[data-vhp-calc-plan-note]');
    if (note) note.hidden = started;
    // Worked out for the typical visitor: say so, with "Anpassen" (the line's own edit button replaces the small one).
    const body = readJson(sessionStorage, CALC_KEY);
    const assumed = !started && !root.dataset.remembered && Boolean(body?.assumed) && validBody(body);
    const assumedLine = root.querySelector('[data-vhp-calc-assumed]');
    if (assumedLine) {
      assumedLine.hidden = !assumed;
      const text = assumedLine.querySelector('[data-vhp-calc-assumed-text]');
      // Her weight given (10-29 step): "Mit deinen 65 kg …"; nothing given (portion first, a row tap): the whole body is
      // the typical visitor's and the line says so.
      if (assumed && text) text.textContent = fill(body.weighed || !d.tAssumedAll ? d.tAssumed : d.tAssumedAll, { age: body.age, height: body.height, weight: body.weight });
    }
    const edit = root.querySelector('[data-vhp-calc-edit-wrap]');
    if (edit) edit.hidden = started || assumed;
    root.dataset.started = started ? '1' : '';
    applyPortion(root, p, { scroll: !opts.view });
    calcView(root, opts.view || 'result');
    if (!opts.view) replay(root.querySelector('[data-vhp-calc-result]'), 'is-reveal');
  };

  // Portion first (docs/PORTION_FIRST.md batch 1): her portion rewrites the recipe she is reading. Theme setting
  // portion_first (data-portion-first on the body), or ?portion_first=1 for a look on the review theme (kept for the
  // visit). Not in the planner's own sheet (it scales with its own portions).
  const PF_KEY = 'vhp_portion_first';
  const portionFirst = (host) => {
    if (document.body.classList.contains('vhp-planner-page')) return false;
    if (host.dataset.portionFirst === 'true') return true;
    try {
      if (/[?&]portion_first=1\b/.test(location.search)) sessionStorage.setItem(PF_KEY, '1');
      return sessionStorage.getItem(PF_KEY) === '1';
    } catch (e) {
      return false;
    }
  };
  // Für mich kochen (docs/PORTION_FIRST.md 13), on top of portion first: theme setting portion_cook (data-portion-cook
  // on the body), or ?portion_cook=1 for a look, kept for the visit.
  const PC_KEY = 'vhp_portion_cook';
  const cookMode = (host) => {
    if (!host || !portionFirst(host)) return false;
    if (host.dataset.portionCook === 'true') return true;
    try {
      if (/[?&]portion_cook=1\b/.test(location.search)) sessionStorage.setItem(PC_KEY, '1');
      return sessionStorage.getItem(PC_KEY) === '1';
    } catch (e) {
      return false;
    }
  };
  // The article with the two buttons (docs/PORTION_FIRST.md 14): no row of her own, her numbers go into the recipe's
  // four tiles once the result is in, the pill under them is the way to change them.
  const inTiles = (host) => Boolean(host?.querySelector('[data-vhp-strip-choice]'));
  const countTiles = (host, p) => {
    host.querySelectorAll('[data-vhp-strip] .vhp-recipe-macro[data-base]').forEach((el) => {
      const base = parseFloat(el.dataset.base);
      if (!Number.isFinite(base)) return;
      if (!el.dataset.n) el.dataset.n = String(Math.round(base));
      countTo(el, base * (p ? p.scale : 1), el.dataset.suffix || '');
    });
  };
  const amountText = (el, p) => fill(p.scale <= 1 ? el.dataset.tOne : el.dataset.tOther, { n: p.amount });
  // Cook mode: her row under the recipe's numbers. "?" until her body is known; while she answers her numbers
  // count in and move (is-live, the label is her day so every slider step shows); after the result the row is hers
  // (is-known, label = goal · weight · meal, "Anpassen").
  const paintMine = (host, p, { live = false, label = '' } = {}) => {
    const row = host?.querySelector('[data-vhp-strip-mine]');
    if (!row) return;
    row.classList.toggle('is-live', Boolean(p) && live);
    row.classList.toggle('is-known', Boolean(p) && !live);
    row.querySelectorAll('[data-vhp-mine-n]').forEach((el) => {
      const base = parseFloat(el.dataset.base);
      if (!p || !Number.isFinite(base)) {
        el.dataset.n = '';
        el.textContent = '?';
        return;
      }
      countTo(el, base * p.scale, el.dataset.suffix || '');
    });
    const labelEl = row.querySelector('[data-vhp-strip-mine-label]');
    if (labelEl) labelEl.textContent = label || row.dataset.tLabel;
    const go = row.querySelector('[data-vhp-strip-mine-go]');
    if (go) {
      go.textContent = p && !live ? row.dataset.tEdit : row.dataset.tGo;
      go.hidden = live;
    }
  };
  // The pill's words (goal · weight · meal), also the label of her row in cook mode.
  const pillText = (host, root, p) => {
    const pill = host?.querySelector('[data-vhp-strip-pill]');
    if (!pill) return '';
    const b = readJson(sessionStorage, CALC_KEY);
    const goal = (validBody(b) && b.goal) || root.dataset.goal || storedDay()?.goal || 'lose';
    const weight = (validBody(b) && b.weight) || CALC_ASSUMED.weight;
    return fill(pill.dataset.tPill, { goal: pill.dataset[`tGoal${cap1(goal)}`] || goal, weight, meal: pill.dataset[`tMeal${cap1(p.meal)}`] || p.meal });
  };
  // "Für wen kochst du?" (cook mode): 1, 2 or 3 times her portion, or the recipe ("0", with its stepper).
  const WHO_T = { 1: 'tWhoMe', 2: 'tWhoTwo', 3: 'tWhoPrep' };
  const whoPick = (host) => (host._portion && host.dataset.yours === 'on' ? host.dataset.people || '1' : host._whoWant || '0');
  const paintWho = (host) => {
    const who = host.querySelector('[data-vhp-who]');
    if (!who) return;
    const pick = whoPick(host);
    who.querySelectorAll('[data-vhp-who-pick]').forEach((btn) => btn.setAttribute('aria-checked', btn.dataset.vhpWhoPick === pick ? 'true' : 'false'));
    host.classList.toggle('is-who-recipe', pick === '0');
  };
  // recipe_choice shown: the two buttons on screen (docs/PORTION_FIRST.md 14).
  const choiceSeen = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) =>
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            choiceSeen.unobserve(entry.target);
            window.vhpPlannerEvents?.step('recipe_choice', 'shown');
          }),
        { threshold: 0.5 }
      )
    : null;
  // Cook mode on this body: her row and the value line instead of the question line, the who control instead of the
  // stepper. known: a portion is (about to be) painted.
  const cookReveal = (host, known) => {
    host.classList.add('is-cook');
    host.classList.toggle('is-tiles', inTiles(host));
    // The choice (article only, docs/PORTION_FIRST.md 14): before her portion and before she picked, the two buttons
    // stand in for her row and the value line.
    const choice = host.querySelector('[data-vhp-strip-choice]');
    // Buttons off (theme setting recipe_choice_buttons, docs/RECIPE_PAGE_REBUILD.md): only the link next to "Pro Portion".
    const choosing = Boolean(choice) && !choice.hasAttribute('data-vhp-choice-off') && !known && !host._choice;
    if (choice) {
      choice.hidden = !choosing;
      if (choosing && choiceSeen) choiceSeen.observe(choice);
    }
    const row = host.querySelector('[data-vhp-strip-mine]');
    if (row) row.hidden = choosing || inTiles(host);
    // The article: "Wie viel davon passt zu mir?" next to "Pro Portion" until she has a portion or opened the questions.
    const line = host.querySelector('[data-vhp-strip-line]');
    if (line) line.hidden = known || Boolean(host._choice);
    const value = host.querySelector('[data-vhp-strip-value]');
    if (value) value.hidden = known || Boolean(choice);
    const who = host.querySelector('[data-vhp-who]');
    if (who) who.hidden = false;
    if (!known) paintMine(host, null);
    paintWho(host);
  };
  // The strip: plates + "½ Portion für dich · für dein Mittagessen", her numbers counting into the four tiles, the
  // recipe's own portion as the small line. The calculator card below drops its own hero and tiles (is-stripped).
  const applyPortion = (root, p, { scroll = true } = {}) => {
    const host = root.closest('[data-vhp-recipe-body]');
    if (!host || !p || !portionFirst(host)) return;
    const cook = cookMode(host) && Boolean(host.querySelector('[data-vhp-strip-mine]'));
    const tiles = !cook || inTiles(host);
    host._portion = p;
    host.dataset.yoursScale = String(p.scale);
    // Cook mode: "Rezept" picked after a portion stays picked when the portion changes.
    host.dataset.yours = cook && host._whoRecipe ? 'off' : 'on';
    root.classList.add('is-stripped');
    // Cook mode: she asked at the ingredients ("Für mich" before any answers): her list in that many portions, and
    // back to it once the result is in.
    const back = cook && host._whoWant && host._whoWant !== '0' ? host._whoWant : '';
    if (back) {
      host.dataset.people = back;
      host._whoWant = '';
      const who = host.querySelector('[data-vhp-who]');
      if (who && scroll) window.setTimeout(() => who.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' }), 400);
    }
    const strip = host.querySelector('[data-vhp-strip]');
    if (strip) {
      const head = strip.querySelector('[data-vhp-strip-yours]');
      if (head) {
        const forText = root.dataset[`tFor${cap1(p.meal)}`] || '';
        // 2026-11-01: no "the pot makes n meals" line any more (Maxim: unclear); her portion and the meal only.
        paintPlates(head.querySelector('[data-vhp-strip-plates]'), p.scale);
        head.querySelector('[data-vhp-strip-amount]').textContent = fill(strip.dataset.tYours, { amount: amountText(strip, p) });
        head.querySelector('[data-vhp-strip-for]').textContent = forText;
        head.hidden = false;
      }
      if (cook) cookReveal(host, true);
      // Cook mode elsewhere (sheets): the recipe's numbers stay as they are, hers fill the row under them. The article
      // and the classic mode: hers in the tiles, the recipe's portion as the small line.
      if (tiles) countTiles(host, p);
      else paintMine(host, p, { label: root.dataset.started ? '' : pillText(host, root, p) });
      const perA = strip.querySelector('[data-vhp-strip-per-a]');
      const perB = strip.querySelector('[data-vhp-strip-per-b]');
      if (perA && perB && tiles) {
        perB.textContent = fill(strip.dataset.tRecipe, { kcal: fmt(Number(host.dataset.kcal) || 0), protein: fmt(Number(host.dataset.protein) || 0) });
        perA.hidden = true;
        perB.hidden = false;
      }
      strip.classList.add('is-yours');
      replay(strip, 'is-reveal');
      // The result she asked for sits above the card she tapped in: bring it back on screen (not while she is
      // dragging a slider in the Für-dich step).
      if (scroll && !back && strip.getBoundingClientRect().top < 0) strip.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
    }
    paintIngs(host);
    host.dispatchEvent(new CustomEvent('vhp:portion-applied', { bubbles: true }));
  };
  // The ingredient list in her portion (people × her portion), or the recipe's own portions after "Original-Rezept".
  const paintIngs = (host) => {
    const cap = host.querySelector('[data-vhp-ings-yours]');
    const p = host._portion;
    if (!cap || !p) return;
    const on = host.dataset.yours === 'on';
    const d = cap.dataset;
    const text = cap.querySelector('[data-vhp-ings-yours-text]');
    const btn = cap.querySelector('[data-vhp-ings-toggle]');
    const cook = host.classList.contains('is-cook');
    const whoT = cook && on ? d[WHO_T[host.dataset.people || '1']] : '';
    if (text) {
      if (whoT) text.textContent = fill(whoT, { kcal: fmt(p.kcalN), protein: fmt(p.proteinN) });
      else text.textContent = on ? fill(d.tYours, { amount: amountText(cap, p), kcal: fmt(p.kcalN) }) : fill(d.tOriginal, { n: d.portions });
    }
    if (btn) btn.textContent = on ? fill(d.tOriginalCta, { n: d.portions }) : d.tYoursCta;
    cap.hidden = false;
    const planA = host.querySelector('[data-vhp-ings-plan-a]');
    const planB = host.querySelector('[data-vhp-ings-plan-b]');
    if (planA && planB) {
      planA.hidden = on;
      planB.hidden = !on;
    }
    window.vhpRecipeBody?.repaint?.(host);
    if (cook) paintWho(host);
  };
  document.addEventListener('click', (event) => {
    const toggle = event.target instanceof Element ? event.target.closest('[data-vhp-ings-toggle]') : null;
    const host = toggle?.closest('[data-vhp-recipe-body]');
    if (!host) return;
    host.dataset.yours = host.dataset.yours === 'on' ? 'off' : 'on';
    window.vhpTrack?.('recipe_calc', { step: 'ings', yours: host.dataset.yours });
    paintIngs(host);
  });

  // The day pattern step: their day on top (kcal per meal, counting), the bar below it, the six patterns.
  const paintMeals = (root) => {
    const preset = root._preset;
    const shares = MEAL_PRESETS[preset] || currentShares();
    const day = root._day || targetDay();
    pressOnly(root, 'data-vhp-calc-preset', preset, 'aria-checked');
    MEAL_IDS.forEach((id) => {
      const cell = root.querySelector(`[data-vhp-calc-cell="${id}"]`);
      const on = shares[id] > 0;
      if (cell) {
        cell.classList.toggle('is-off', !on);
        const kcal = cell.querySelector('[data-vhp-calc-cell-kcal]');
        // A meal they skip says so ("aus"), not 0 kcal.
        if (kcal && day && on) countTo(kcal, (day.kcal * shares[id]) / 100);
        else if (kcal) {
          kcal.dataset.n = '0';
          kcal.textContent = root.dataset.tOff || '';
        }
      }
      const part = root.querySelector(`[data-vhp-calc-bar] [data-meal="${id}"]`);
      if (part) part.style.flexGrow = String(shares[id]);
    });
  };

  // Sliders: the value above the track, the track filled up to the thumb.
  const paintSlider = (input) => {
    const min = Number(input.min);
    const max = Number(input.max);
    const value = Number(input.value);
    input.style.setProperty('--p', `${((value - min) / (max - min || 1)) * 100}%`);
    const out = input.closest('[data-vhp-calc]')?.querySelector(`[data-vhp-calc-out="${input.dataset.vhpCalcIn}"]`);
    if (out) {
      out.textContent = String(value);
      if (input.dataset.unit) {
        const unit = document.createElement('small');
        unit.textContent = input.dataset.unit;
        out.append(unit);
      }
    }
  };
  const setSlider = (root, key, value) => {
    const input = root.querySelector(`[data-vhp-calc-in="${key}"]`);
    if (!input) return;
    input.value = String(Math.min(Number(input.max), Math.max(Number(input.min), Math.round(value))));
    paintSlider(input);
  };

  const fillForm = (root, saved) => {
    const body = saved && saved.sex ? saved : null;
    root.dataset.sex = body?.sex || '';
    pressOnly(root, 'data-vhp-calc-sex', root.dataset.sex, 'aria-checked');
    paintSeg(root.querySelector('[data-vhp-calc-sexes]'));
    ['weight', 'height', 'age'].forEach((key) => setSlider(root, key, body?.[key] ?? CALC_START[key]));
    root.querySelector('[data-vhp-calc-error]').hidden = true;
    pressOnly(root, 'data-vhp-calc-goal', root.dataset.goal);
  };

  const readForm = (root) => {
    const num = (key) => Number(root.querySelector(`[data-vhp-calc-in="${key}"]`)?.value || 0);
    return { goal: root.dataset.goal, sex: root.dataset.sex, weight: num('weight'), height: num('height'), age: num('age') };
  };

  // Where a calculator sits: a swipe card's own sheet (data-vhp-card-calc), the recipe sheet, or the recipe page. The
  // recipe sheet mounts its body before it is in the page, so a calculator outside the document is a sheet's.
  const calcWhere = (root) => {
    if (root.closest('[data-vhp-card-calc]')) return 'card';
    return root.closest('.rsheet') || !root.isConnected ? 'sheet' : 'page';
  };

  // calc_use (2026-10-26): the calculator's own funnel per surface: its question on screen, a goal tapped, "Anpassen" /
  // "Ändern" opened, their own body sent. portion_calc stays the result shown.
  const calcUse = (root, what) => window.vhpPlannerEvents?.step('calc_use', `${what}_${calcWhere(root)}`);
  // Flow mode (docs/PORTION_FIRST.md 11): real questions (Ziel → Über dich → Alltag), no assumed body; on the recipe
  // page folded under the strip until "Für mich berechnen".
  const flowMode = (root) => root.dataset.flow === '1';
  const askLineOf = (root) => root.closest('[data-vhp-strip]')?.querySelector('[data-vhp-strip-ask]') || null;
  const flowReveal = (root, known) => {
    if (!flowMode(root)) return;
    const line = askLineOf(root);
    if (!line) return; // the swipe card's sheet: the flow runs unfolded
    const host = root.closest('[data-vhp-recipe-body]');
    if (cookMode(host) && host.querySelector('[data-vhp-strip-mine]')) {
      line.hidden = true;
      cookReveal(host, known);
    } else line.hidden = known;
    root.hidden = !known;
  };
  const openFlow = (root) => {
    const line = askLineOf(root);
    if (line) line.hidden = true;
    root.hidden = false;
    calcView(root, 'ask');
    window.vhpTrack?.('recipe_calc', { step: 'open', where: calcWhere(root) });
  };
  const toMine = (host) => {
    if (inTiles(host)) {
      // The tiles just under the sticky top bar, the questions right below them.
      const stats = host.querySelector('[data-vhp-strip] .vhp-recipe-sheet__stats');
      const bar = document.querySelector('.app-topbar')?.getBoundingClientRect().bottom || 0;
      if (stats) window.scrollTo({ top: stats.getBoundingClientRect().top + window.scrollY - Math.max(0, bar) - 12, behavior: reduced() ? 'auto' : 'smooth' });
      return;
    }
    const row = host.querySelector('[data-vhp-strip-mine]');
    if (row) row.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
  };
  document.addEventListener('click', (event) => {
    const t = event.target instanceof Element ? event.target : null;
    const go = t?.closest('[data-vhp-strip-go]');
    if (go) {
      const root = go.closest('[data-vhp-strip]')?.querySelector('[data-vhp-calc]');
      if (root) openFlow(root);
      return;
    }
    // Cook mode: her row. Before any answer it opens the questions (and stays on screen above them); with her
    // portion it opens the Für-dich step; from a planner preview it shows the card.
    const mine = t?.closest('[data-vhp-strip-mine]');
    const host = mine?.closest('[data-vhp-recipe-body]');
    const root = host?.querySelector('[data-vhp-strip] [data-vhp-calc]');
    if (!root) return;
    if (root.dataset.started) {
      root.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
      return;
    }
    if (host._portion && !root.hidden) {
      openTune(root);
      toMine(host);
      return;
    }
    if (root.hidden) openFlow(root);
    toMine(host);
  });
  // The choice: "adapt" = her row and the questions (as a tap on the row), "recipe" = down to the ingredients and the
  // buttons stay (the article never shows the "?" row, Maxim 11-01: one entry, not two), "line" = the link next to
  // "Pro Portion", as adapt. recipe_choice: adapt, recipe, line (shown: choiceSeen).
  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-vhp-choice]') : null;
    const host = btn?.closest('[data-vhp-recipe-body]');
    if (!host) return;
    event.preventDefault();
    const pick = btn.dataset.vhpChoice;
    window.vhpPlannerEvents?.step('recipe_choice', pick);
    window.vhpTrack?.('recipe_calc', { step: 'choice', pick });
    if (pick === 'adapt' || pick === 'line') {
      host._choice = pick;
      cookReveal(host, false);
      const root = host.querySelector('[data-vhp-strip] [data-vhp-calc]');
      if (root?.hidden) openFlow(root);
      toMine(host);
      return;
    }
    // The ingredients, just under the sticky top bar.
    const to = host.querySelector('#ingredients');
    if (!to) return;
    const bar = document.querySelector('.app-topbar')?.getBoundingClientRect().bottom || 0;
    window.scrollTo({ top: to.getBoundingClientRect().top + window.scrollY - Math.max(0, bar) - 12, behavior: reduced() ? 'auto' : 'smooth' });
  });
  // Cook mode: "Für wen kochst du?". With her portion: her list in 1, 2 or 3 portions, or the recipe's own ("0");
  // without it a tap asks the questions first and the list follows the result (applyPortion).
  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-vhp-who-pick]') : null;
    const host = btn?.closest('[data-vhp-recipe-body]');
    if (!host) return;
    tick();
    const pick = btn.dataset.vhpWhoPick;
    window.vhpTrack?.('recipe_calc', { step: 'who', who: pick, known: Boolean(host._portion) });
    if (host._portion) {
      host._whoRecipe = pick === '0';
      if (pick === '0') {
        host.dataset.yours = 'off';
        delete host.dataset.servings;
      } else {
        host.dataset.yours = 'on';
        host.dataset.people = pick;
      }
      paintIngs(host);
      return;
    }
    host._whoWant = pick;
    paintWho(host);
    if (pick === '0') return;
    const root = host.querySelector('[data-vhp-strip] [data-vhp-calc]');
    if (!root) return;
    if (root.hidden) openFlow(root);
    toMine(host);
  });
  // Cook mode, before her first result: her numbers in the row while she answers (sex tapped, sliders, the goal).
  // Activity not answered yet counts as light, as in the planner; the result itself still waits for her answer.
  // Not on the article (inTiles): the recipe's tiles change only with the finished result (Maxim 11-01).
  const livePreview = (root) => {
    const host = root.closest('[data-vhp-recipe-body]');
    if (!flowMode(root) || host?._portion || !cookMode(host) || inTiles(host)) return;
    const body = { ...readForm(root), goal: root.dataset.goal || 'lose', activity: root._flowBody?.activity || '' };
    if (!validBody(body)) {
      const pill = host.querySelector('[data-vhp-strip-pill]');
      const goal = root.dataset.goal ? pill?.dataset[`tGoal${cap1(root.dataset.goal)}`] || '' : '';
      const label = host.querySelector('[data-vhp-strip-mine]')?.dataset.tName || '';
      paintMine(host, null, { label: goal ? `${label}: ${goal}` : '' });
      return;
    }
    const day = dayOf(body);
    const p = portionOf({ kcal: root.dataset.kcal, protein: root.dataset.protein, slot: root.dataset.slot }, day, currentShares(), root.dataset.meal || '');
    const tLive = host.querySelector('[data-vhp-strip-mine]')?.dataset.tLive || root.dataset.tDay;
    paintMine(host, p, { live: true, label: fill(tLive, { amount: fill(p.scale <= 1 ? root.dataset.tOne : root.dataset.tOther, { n: p.amount }), kcal: fmt(day.kcal), protein: fmt(day.protein) }) });
  };
  const calcSeen = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) =>
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            calcSeen.unobserve(entry.target);
            const root = entry.target.closest('[data-vhp-calc]');
            if (root) calcUse(root, 'seen');
          }),
        { threshold: 0.5 }
      )
    : null;

  // Called by the recipe body (window.vhpRecipeBody.enhance): the article and every sheet that opens, and by the swipe
  // feed for the calculator a card's numbers open (assets/vhp-collection-reels.js). A known target shows the result
  // right away and counts as a "Für dich" view (portion_seen).
  const mountCalc = (node) => {
    if (!node?.matches?.('[data-vhp-calc]')) pruneCalcs(node); // a page or a freshly rendered sheet body
    // The swipe card's calculator is mounted by the feed when it opens (with that card's dish), never with the page.
    const roots = node?.matches?.('[data-vhp-calc]')
      ? [node]
      : Array.from(node?.querySelectorAll?.('[data-vhp-calc]') || []).filter((root) => !root.closest('[data-vhp-card-calc]'));
    roots.forEach((root) => {
      delete root.dataset.remembered;
      delete root.dataset.view;
      root._preset = null;
      // A remembered result that fails to paint (2026-10-30, an empty card seen on Maxim's phone) must not leave an
      // empty card: back to the question, and the error goes to tracking.
      const paintKnown = (day, started) => {
        try {
          flowReveal(root, true);
          paintResult(root, day, started);
          window.vhpPlannerEvents?.step('portion_seen', calcWhere(root));
          return true;
        } catch (e) {
          window.vhpTrack?.('recipe_calc', { step: 'error', where: calcWhere(root), message: String(e && e.message).slice(0, 120) });
          delete root.dataset.remembered;
          flowReveal(root, false);
          pressOnly(root, 'data-vhp-calc-goal', '');
          paintAsk(root);
          calcView(root, 'ask');
          return false;
        }
      };
      const planned = plannerDay();
      if (planned) {
        paintKnown(planned, true);
        return;
      }
      const saved = readJson(sessionStorage, CALC_KEY);
      if (validBody(saved)) {
        root.dataset.goal = saved.goal;
        paintKnown(dayOf(saved), false);
        return;
      }
      const stored = storedDay();
      if (stored) {
        // From an earlier visit: the plan link counts as portion_line, "Ändern" asks the body again.
        root.dataset.goal = stored.goal;
        root.dataset.remembered = '1';
        paintKnown(stored, false);
        return;
      }
      pressOnly(root, 'data-vhp-calc-goal', '');
      flowReveal(root, false);
      paintAsk(root);
      calcView(root, 'ask');
      const ask = root.querySelector('[data-vhp-calc-ask]');
      if (ask && calcSeen) calcSeen.observe(ask);
    });
  };
  // Portion first, batch 2 (docs/PORTION_FIRST.md 5.1): in a recipe body with the strip the three goal rows carry the
  // answer for the typical visitor (or her own weight from this visit) before any tap, "Wie viel davon für dich?" on
  // top, the body it was worked out for under them with Anpassen (the weight step). The swipe card's own sheet keeps
  // the question.
  const firstMode = (root) => {
    const host = root.closest('[data-vhp-recipe-body]');
    return Boolean(host && host.querySelector('[data-vhp-strip]') && portionFirst(host));
  };
  const paintAsk = (root) => {
    if (flowMode(root)) {
      // Flow mode asks instead of assuming (docs/PORTION_FIRST.md 11): the first question is just "Dein Ziel".
      const q = root.querySelector('[data-vhp-calc-q]');
      if (q && root.dataset.tQFlow) q.textContent = root.dataset.tQFlow;
      return;
    }
    if (!firstMode(root)) return;
    const d = root.dataset;
    root.dataset.first = '1';
    // knownBody() is declared further down; mountPage runs before that line, so read the visit's answers here.
    const saved = readJson(sessionStorage, CALC_KEY);
    const known = validBody(saved) && (!saved.assumed || saved.weighed) ? saved : null;
    const q = root.querySelector('[data-vhp-calc-q]');
    if (q && d.tQFirst) q.textContent = d.tQFirst;
    const sub = root.querySelector('[data-vhp-calc-sub]');
    if (sub) sub.hidden = true;
    root.querySelectorAll('[data-vhp-calc-goal]').forEach((btn) => {
      const btnGoal = goalOf(btn.dataset.vhpCalcGoal);
      const body = known ? { ...known, goal: btnGoal } : { goal: btnGoal, ...CALC_ASSUMED, assumed: true };
      const p = portionOf({ kcal: d.kcal, protein: d.protein, slot: d.slot }, dayOf(body), currentShares());
      const small = btn.querySelector('[data-vhp-calc-goal-sub]');
      if (!p || !small) return;
      small.textContent = fill(d.tAnswer, { amount: fill(p.scale <= 1 ? d.tOne : d.tOther, { n: p.amount }), kcal: fmt(p.kcalN) });
    });
    const line = root.querySelector('[data-vhp-calc-ask-assumed]');
    const text = line?.querySelector('[data-vhp-calc-ask-assumed-text]');
    if (line && text) {
      const b = known || CALC_ASSUMED;
      text.textContent = fill(known && known.weighed ? d.tAssumed : d.tAssumedAll, { age: b.age, height: b.height, weight: b.weight });
      line.hidden = false;
    }
  };
  // Batch 3 (docs/PORTION_FIRST.md 5.3): the Für-dich step. Opened from the strip's pill and from the result's
  // Anpassen; goal chips, her weight (live), the meal this dish is for (root.dataset.meal), the day pattern (the meals
  // step), Mehr (the body step). Every change repaints strip, card and amounts without leaving the step.
  const tuneBody = (root) => {
    const saved = readJson(sessionStorage, CALC_KEY);
    if (validBody(saved)) return { ...saved, goal: saved.goal || root.dataset.goal || 'lose' };
    return { goal: root.dataset.goal || storedDay()?.goal || 'lose', ...CALC_ASSUMED, assumed: true };
  };
  const paintTune = (root, body) => {
    pressOnly(root, 'data-vhp-calc-tune-goal', body.goal);
    pressOnly(root, 'data-vhp-calc-tune-meal', root.dataset.meal || root._lastMeal || '');
    setSlider(root, 'tune_weight', body.weight);
  };
  const retune = (root, body) => {
    if (!validBody(body)) return;
    root.dataset.goal = body.goal;
    try {
      sessionStorage.setItem(CALC_KEY, JSON.stringify(body));
    } catch (e) {
      /* private mode: this recipe only */
    }
    delete root.dataset.remembered;
    const day = dayOf(body);
    paintResult(root, day, false, { view: 'tune' });
    keepTarget(body.goal, day);
    paintTune(root, body);
  };
  const openTune = (root, from) => {
    const body = tuneBody(root);
    calcUse(root, 'adjust');
    root._day = dayOf(body);
    paintTune(root, body);
    paintMealsRow(root, currentShares());
    calcView(root, 'tune');
    if (from === 'pill') root.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
  };
  document.addEventListener('click', (event) => {
    const pill = event.target instanceof Element ? event.target.closest('[data-vhp-strip-pill]') : null;
    const root = pill?.closest('[data-vhp-recipe-body]')?.querySelector('[data-vhp-calc]');
    if (root) openTune(root, 'pill');
  });
  // The "Deine Portion" slide in the reel (docs/PORTION_FIRST.md 10, assets/vhp-collection-reels.js paintPortionCard):
  // the answer per goal for one dish, the one-tap commit, and the card calculator opened on the weight step.
  const bodyKnown = () => {
    const saved = readJson(sessionStorage, CALC_KEY);
    return validBody(saved) && (!saved.assumed || saved.weighed) ? saved : null;
  };
  const answersFor = (dish) => {
    const known = bodyKnown();
    const base = known || { ...CALC_ASSUMED, assumed: true };
    const out = { body: { age: base.age, height: base.height, weight: base.weight, weighed: Boolean(known && known.weighed) } };
    Object.keys(GOAL_DELTA).forEach((goal) => {
      out[goal] = portionOf(dish, dayOf({ ...base, goal }), currentShares());
    });
    return out;
  };
  const chooseGoal = (goal, dish, where = 'deck') => {
    if (GOAL_DELTA[goal] == null) return null;
    const known = bodyKnown();
    const body = known ? { ...known, goal } : { goal, ...CALC_ASSUMED, assumed: true };
    try {
      sessionStorage.setItem(CALC_KEY, JSON.stringify(body));
    } catch (e) {
      /* private mode: this page only */
    }
    const day = dayOf(body);
    keepTarget(goal, day);
    window.vhpTrack?.('recipe_calc', { step: 'result', goal, where });
    window.vhpPlannerEvents?.step('calc_use', `goal_${where}`);
    window.vhpPlannerEvents?.step('portion_calc', where);
    return { body, portion: portionOf(dish, day, currentShares()) };
  };
  const adjustCalc = (root) => {
    if (!root) return;
    if (!root.dataset.goal) {
      root.dataset.goal = 'lose';
      pressOnly(root, 'data-vhp-calc-goal', 'lose');
    }
    setSlider(root, 'quick_weight', bodyKnown()?.weight || CALC_START.weight);
    calcView(root, 'weight');
  };
  window.vhpPortionCalc = { mount: mountCalc, day: targetDay, portion: portionOf, answers: answersFor, choose: chooseGoal, adjust: adjustCalc };
  // A recipe body carries both calculators (the classic card in the action row, the question flow in the strip,
  // snippets/vhp-recipe-body.liquid); keep the one the mode wants, before anything mounts.
  // The sheet hands over the recipe body itself (assets/vhp-recipe-sheet.js mountBody), which querySelectorAll skips.
  const pruneCalcs = (node) => {
    const hosts = node?.matches?.('[data-vhp-recipe-body]') ? [node] : node?.querySelectorAll?.('[data-vhp-recipe-body]') || [];
    hosts.forEach((host) => {
      const flow = host.querySelector('[data-vhp-strip] [data-vhp-calc][data-flow]');
      if (!flow) return;
      if (portionFirst(host)) host.querySelectorAll('.rsheet__actions [data-vhp-calc]').forEach((el) => el.remove());
      else {
        flow.remove();
        host.querySelector('[data-vhp-strip-ask]')?.remove();
      }
    });
  };
  const mountPage = () => {
    pruneCalcs(document);
    mountCalc(document);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountPage, { once: true });
  else mountPage();

  const tick = () => {
    try {
      navigator.vibrate?.(8);
    } catch (e) {
      /* no haptics */
    }
  };

  const calcGo = (root) => {
    const body = readForm(root);
    if (!body.sex) {
      root.querySelector('[data-vhp-calc-error]').hidden = false;
      replay(root.querySelector('[data-vhp-calc-sexes]'), 'is-shake');
      return;
    }
    if (!validBody(body)) return;
    // Flow mode: one more question (her everyday activity) before the result.
    if (flowMode(root)) {
      root._flowBody = body;
      pressOnly(root, 'data-vhp-calc-activity-pick', readJson(sessionStorage, CALC_KEY)?.activity || '');
      calcView(root, 'activity');
      return;
    }
    calcCommit(root, body);
  };
  // Her first result of the visit (2026-10-31): the done step (ring, tick, burst, "Ab jetzt …") plays first, then the
  // result counts in. Later answers go straight to the result. A tap skips it; it moves on by itself.
  const CHEER_KEY = 'vhp_calc_cheered';
  const cheer = (root, then) => {
    const step = root.querySelector('[data-vhp-calc-done]');
    let seen = false;
    try {
      seen = sessionStorage.getItem(CHEER_KEY) === '1';
      sessionStorage.setItem(CHEER_KEY, '1');
    } catch (e) {
      /* private mode: every result cheers */
    }
    if (!step || seen) {
      then();
      return;
    }
    let left = false;
    const go = () => {
      if (left) return;
      left = true;
      window.clearTimeout(timer);
      window.clearTimeout(buzz);
      step.removeEventListener('click', go);
      then();
    };
    calcView(root, 'done');
    // The tick lands with the check mark.
    const buzz = window.setTimeout(() => {
      try {
        navigator.vibrate?.([10, 50, 16]);
      } catch (e) {
        /* no haptics */
      }
    }, reduced() ? 0 : 900);
    const timer = window.setTimeout(go, reduced() ? 2400 : 3400);
    step.addEventListener('click', go);
  };

  // Her answers become the target: kept for the visit, the day target for 60 days, the result painted.
  const calcCommit = (root, body) => {
    try {
      sessionStorage.setItem(CALC_KEY, JSON.stringify(body));
    } catch (e) {
      /* private mode: this recipe only */
    }
    delete root.dataset.remembered;
    cheer(root, () => paintResult(root, dayOf(body), false));
    keepTarget(body.goal, dayOf(body));
    const where = calcWhere(root);
    window.vhpTrack?.('recipe_calc', { step: 'result', goal: body.goal, where });
    window.vhpPlannerEvents?.step('portion_calc', where);
    calcUse(root, 'body');
  };

  // This visit's answers that already carry her own weight (her full body, or the weight step): the goal tap goes
  // straight to the result.
  const knownBody = () => {
    const saved = readJson(sessionStorage, CALC_KEY);
    return validBody(saved) && (!saved.assumed || saved.weighed) ? saved : null;
  };
  // The result for her weight (or her whole body from this visit), the rest the typical visitor's (CALC_ASSUMED).
  const calcAssumed = (root, weight) => {
    const known = knownBody();
    const body = weight
      ? { goal: root.dataset.goal, ...CALC_ASSUMED, weight, assumed: true, weighed: true }
      : known
        ? { ...known, goal: root.dataset.goal }
        : root.dataset.first
          ? { goal: root.dataset.goal, ...CALC_ASSUMED, assumed: true }
          : null;
    if (!body || !validBody(body)) return;
    if (!validBody(body)) return;
    try {
      sessionStorage.setItem(CALC_KEY, JSON.stringify(body));
    } catch (e) {
      /* private mode: this recipe only */
    }
    delete root.dataset.remembered;
    cheer(root, () => paintResult(root, dayOf(body), false));
    keepTarget(body.goal, dayOf(body));
    const where = calcWhere(root);
    window.vhpTrack?.('recipe_calc', { step: 'result', goal: body.goal, where });
    window.vhpPlannerEvents?.step('portion_calc', where);
  };


  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const root = target?.closest('[data-vhp-calc]');
    if (!root) return;
    const goalBtn = target.closest('[data-vhp-calc-goal]');
    if (goalBtn) {
      if (root._picking) return;
      tick();
      // "Einfach gut essen" (2026-11-01, docs/RECIPE_CRO_ATTACK_PLAN.md Q9) is the maintain target under a calmer name.
      root.dataset.goal = goalOf(goalBtn.dataset.vhpCalcGoal);
      pressOnly(root, 'data-vhp-calc-goal', goalBtn.dataset.vhpCalcGoal);
      replay(goalBtn, 'is-picked');
      window.vhpTrack?.('recipe_calc', { step: 'goal', goal: root.dataset.goal, where: calcWhere(root) });
      calcUse(root, 'goal');
      // The pick shows for a moment, then her portion (weight known this visit) or the weight question slides in.
      root._picking = true;
      window.setTimeout(() => {
        root._picking = false;
        // Flow mode: her body next (no assumption), unless this visit already answered it.
        if (flowMode(root) && !knownBody()) {
          fillForm(root, readJson(sessionStorage, CALC_KEY));
          calcView(root, 'form');
          livePreview(root);
          return;
        }
        // Her weight known this visit, or portion first (the row already showed the answer): the result at once.
        if (knownBody() || root.dataset.first) {
          calcAssumed(root);
          return;
        }
        setSlider(root, 'quick_weight', CALC_START.weight);
        calcView(root, 'weight');
      }, reduced() ? 0 : 200);
      return;
    }
    if (target.closest('[data-vhp-calc-weigh]')) {
      const input = root.querySelector('[data-vhp-calc-in="quick_weight"]');
      calcAssumed(root, Number(input?.value) || 0);
      return;
    }
    // Batch 3: the Für-dich step's chips and buttons.
    const tuneGoal = target.closest('[data-vhp-calc-tune-goal]');
    if (tuneGoal) {
      tick();
      retune(root, { ...tuneBody(root), goal: tuneGoal.dataset.vhpCalcTuneGoal });
      calcUse(root, 'goal');
      return;
    }
    const tuneMeal = target.closest('[data-vhp-calc-tune-meal]');
    if (tuneMeal) {
      tick();
      root.dataset.meal = tuneMeal.dataset.vhpCalcTuneMeal;
      retune(root, tuneBody(root));
      calcUse(root, 'meal');
      return;
    }
    if (target.closest('[data-vhp-calc-tune-done]')) {
      paintResult(root, root._day || targetDay(), Boolean(root.dataset.started));
      return;
    }
    if (target.closest('[data-vhp-calc-more]')) {
      fillForm(root, readJson(sessionStorage, CALC_KEY));
      calcView(root, 'form');
      return;
    }
    const sexBtn = target.closest('[data-vhp-calc-sex]');
    if (sexBtn) {
      tick();
      root.dataset.sex = sexBtn.dataset.vhpCalcSex;
      pressOnly(root, 'data-vhp-calc-sex', root.dataset.sex, 'aria-checked');
      paintSeg(root.querySelector('[data-vhp-calc-sexes]'));
      root.querySelector('[data-vhp-calc-error]').hidden = true;
      livePreview(root);
      return;
    }
    if (target.closest('[data-vhp-calc-go]')) {
      calcGo(root);
      return;
    }
    const back = target.closest('[data-vhp-calc-back]');
    if (back) {
      calcView(root, back.dataset.to || 'ask');
      return;
    }
    // Flow mode: the activity tile ends the questions, the result follows.
    const act = target.closest('[data-vhp-calc-activity-pick]');
    if (act) {
      tick();
      const base = root._flowBody || readForm(root);
      const body = { ...base, goal: root.dataset.goal || base.goal, activity: act.dataset.vhpCalcActivityPick };
      pressOnly(root, 'data-vhp-calc-activity-pick', body.activity);
      if (!validBody(body)) {
        calcView(root, 'form');
        return;
      }
      replay(act, 'is-picked');
      window.setTimeout(() => calcCommit(root, body), reduced() ? 0 : 160);
      return;
    }
    if (target.closest('[data-vhp-calc-edit]')) {
      // Portion first: Anpassen on the result opens the Für-dich step; elsewhere the body step as before.
      if (firstMode(root)) {
        openTune(root);
        return;
      }
      calcUse(root, 'adjust');
      fillForm(root, readJson(sessionStorage, CALC_KEY));
      calcView(root, root.dataset.goal ? 'form' : 'ask');
      return;
    }
    // Portion first: Anpassen under the answered rows asks her weight (Abnehmen assumed until she picks a row).
    if (target.closest('[data-vhp-calc-adjust]')) {
      calcUse(root, 'adjust');
      if (!root.dataset.goal) {
        root.dataset.goal = 'lose';
        pressOnly(root, 'data-vhp-calc-goal', 'lose');
      }
      setSlider(root, 'quick_weight', knownBody()?.weight || CALC_START.weight);
      calcView(root, 'weight');
      return;
    }
    if (target.closest('[data-vhp-calc-meals-open]')) {
      root._preset = presetOf(currentShares());
      calcView(root, 'meals');
      // Cells count up from 0 the first time the step shows.
      root.querySelectorAll('[data-vhp-calc-cell-kcal]').forEach((el) => {
        if (!el.dataset.n) el.dataset.n = '0';
      });
      paintMeals(root);
      return;
    }
    const presetBtn = target.closest('[data-vhp-calc-preset]');
    if (presetBtn) {
      tick();
      root._preset = presetBtn.dataset.vhpCalcPreset;
      replay(presetBtn, 'is-picked');
      paintMeals(root);
      return;
    }
    if (target.closest('[data-vhp-calc-meals-done]')) {
      if (root._preset && root._preset !== presetOf(currentShares())) keepPreset(root._preset);
      window.vhpTrack?.('recipe_calc', { step: 'meals', where: calcWhere(root), preset: root._preset || 'custom' });
      root._preset = null;
      root._fromMeals = true;
      paintResult(root, root._day || targetDay(), Boolean(root.dataset.started));
      return;
    }
    // The way into the planner: the answers go along (the planner reads them only on a fresh start). The click
    // itself (entry, like, pick) is the plan CTA's, handled below.
    if (target.closest('[data-vhp-calc-plan]') && !root.dataset.started) handCalc();
  });
  // This visit's calculator answers (goal + body) to the planner, which then skips those slides. False without them.
  const handCalc = () => {
    const saved = readJson(sessionStorage, CALC_KEY);
    if (!validBody(saved)) return false;
    try {
      sessionStorage.setItem(
        'vhp_planner_goal',
        JSON.stringify({ goal: saved.goal, body: { sex: saved.sex, weight: saved.weight, height: saved.height, age: saved.age, activity: saved.activity || '' }, assumed: Boolean(saved.assumed) })
      );
      return true;
    } catch (e) {
      return false; // private mode: the planner asks again
    }
  };
  document.addEventListener('input', (event) => {
    const input = event.target instanceof Element ? event.target.closest('[data-vhp-calc-in]') : null;
    if (!input) return;
    paintSlider(input);
    if (['weight', 'height', 'age'].includes(input.dataset.vhpCalcIn)) {
      const root = input.closest('[data-vhp-calc]');
      if (root) {
        window.cancelAnimationFrame(root._liveRaf || 0);
        root._liveRaf = window.requestAnimationFrame(() => livePreview(root));
      }
    }
    // Batch 3: her weight moves the strip and the amounts while she drags (one repaint per frame).
    if (input.dataset.vhpCalcIn === 'tune_weight') {
      const root = input.closest('[data-vhp-calc]');
      if (!root) return;
      window.cancelAnimationFrame(root._tuneRaf || 0);
      root._tuneRaf = window.requestAnimationFrame(() => {
        const weight = Number(input.value) || 0;
        if (!weight) return;
        retune(root, { ...tuneBody(root), weight, weighed: true });
      });
    }
  });
  document.addEventListener('change', (event) => {
    const input = event.target instanceof Element ? event.target.closest('[data-vhp-calc-in="tune_weight"]') : null;
    const root = input?.closest('[data-vhp-calc]');
    if (root) {
      calcUse(root, 'body');
      window.vhpPlannerEvents?.step('portion_calc', calcWhere(root));
    }
  });
  const GOALS = new Set(['lose', 'maintain', 'gain']);
  // planner_entry source of the explainer's CTA per trigger (assets/vhp-planner-events.js ENTRY_MAP).
  const SOURCE = {
    top: 'recipe_goal',
    end: 'recipe_end',
    topbar: 'topbar',
    sidepanel: 'sidepanel',
    card: 'paywall_card',
    sheet: 'paywall_sheet',
    cook: 'paywall_cook',
    page: 'paywall_page',
    // The recipe page's own doors (docs/RECIPE_FUNNEL.md 3), always straight in: cook mode's "Fertig" and the
    // shopping-list line under the ingredients ("Und morgen?" after the method is `end`).
    cooked: 'cook_done',
    list: 'recipe_list',
    // The planner block's button in the sheet the planner line opens (docs/PLANNER_BLOCK.md, assets/vhp-planner-block.js).
    line: 'recipe_top',
  };
  const DIRECT = new Set(['top', 'end', 'cooked', 'list', 'line']);
  // The dish behind the open explainer: named first in the planner when they continue.
  let pickId = '';

  const plannableDish = (data) => (data && data.plannable === 'true' && data.productId ? data : null);

  const likeDish = (d) => {
    window.vhpPlannerLikes?.addLike({
      id: d.productId,
      handle: d.handle,
      title: d.title,
      image: d.image || '',
      slot: d.slot,
      kcal: d.kcal,
      protein: d.protein,
      carbs: d.carbs,
      fat: d.fat,
      time: d.time,
    });
  };

  const keepPick = (id) => {
    if (!id) return;
    try {
      sessionStorage.setItem('vhp_planner_pick', JSON.stringify({ id: String(id) }));
    } catch (e) {
      /* private mode */
    }
  };

  // Started = the planner has their goal or got past its first screen (its saved state, like assets/app-shell.js).
  const started = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(window.vhpPlannerLikes?.STORAGE_KEY || 'vhp_planner_anon') || 'null');
      return Boolean(saved && (saved.goal || (saved.screen && saved.screen !== 'goal')));
    } catch (e) {
      return false;
    }
  };

  const explainer = () => document.querySelector('[data-vhp-px]');

  // Step 2 with their likes: how many are missing for a week, or done (the planner then skips the deck).
  const paintLikes = (sheet) => {
    const note = sheet.querySelector('[data-vhp-px-likes]');
    const step = note?.closest('li');
    const api = window.vhpPlannerLikes;
    if (!note || !api) return;
    const doc = api.read();
    const n = api.likeCount(doc);
    const ready = api.planReady(doc);
    const left = Math.max(0, api.LIKE_READY - n);
    let text = note.dataset.base;
    if (ready) text = note.dataset.ready;
    else if (left === 1) text = note.dataset.leftOne;
    else if (left > 1) text = note.dataset.leftMany.replace('{n}', String(left));
    else if (n) text = note.dataset.needMain;
    note.textContent = text;
    step?.classList.toggle('is-done', ready);
  };

  const openExplainer = (sheet, where, dish) => {
    const d = plannableDish(dish);
    if (d) likeDish(d);
    pickId = d ? d.productId : '';
    const saved = sheet.querySelector('[data-vhp-px-saved]');
    if (saved) {
      saved.hidden = !d;
      if (d) saved.querySelector('span').textContent = saved.dataset.text.replace('{title}', d.title || '');
    }
    paintLikes(sheet);
    const go = sheet.querySelector('[data-vhp-px-go]');
    if (go) go.dataset.trackSource = SOURCE[where] || 'recipe_goal';
    if (window.vhpSheet) window.vhpSheet.setOpen(sheet, true);
    else if (!sheet.open) sheet.showModal();
    sheet.querySelector('.vhp-px__body')?.scrollTo(0, 0);
    sheet.querySelector('#vhp-px-title')?.focus({ preventScroll: true });
    const video = sheet.querySelector('video');
    if (video) void video.play().catch(() => {});
    window.vhpPlannerEvents?.step('planner_explainer', where);
  };

  const closeExplainer = (sheet) => {
    if (window.vhpSheet) window.vhpSheet.setOpen(sheet, false);
    else sheet.close();
  };

  // The week photos load lazily inside the closed dialog: once a trigger is in view, fetch them, so the sheet isn't
  // half empty on a slow connection.
  const warm = (sheet) => {
    const triggers = document.querySelectorAll('[data-vhp-plan-cta]');
    if (!triggers.length || !('IntersectionObserver' in window)) return;
    const seen = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      seen.disconnect();
      sheet.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
    });
    triggers.forEach((el) => seen.observe(el));
  };

  // Escape, the drag and closing from code all end in the dialog's close: the clip stops there.
  const bindExplainer = () => {
    const sheet = explainer();
    if (!sheet || sheet.dataset.vhpPxBound) return;
    sheet.dataset.vhpPxBound = '1';
    sheet.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeExplainer(sheet);
    });
    sheet.addEventListener('close', () => sheet.querySelector('video')?.pause());
    warm(sheet);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindExplainer, { once: true });
  else bindExplainer();

  // For code paths ("Zum Meal Plan hinzufügen", the card's calendar): true when the explainer took over.
  const open = ({ where, dish } = {}) => {
    const sheet = explainer();
    if (!sheet || started()) return false;
    bindExplainer();
    openExplainer(sheet, where, dish);
    return true;
  };
  window.vhpPlanExplainer = { open };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const sheet = explainer();

    if (sheet && (target === sheet || target.closest('[data-vhp-px-close]'))) {
      closeExplainer(sheet);
      return;
    }
    if (target.closest('[data-vhp-px-go]')) {
      keepPick(pickId);
      return;
    }

    const chip = target.closest('[data-vhp-plan-goal] [data-goal]');
    if (chip) {
      const easy = chip.dataset.goal === 'easy';
      if (!easy && !GOALS.has(chip.dataset.goal)) return;
      try {
        // "Einfach gut essen" travels as maintain plus her words (the planner's state.goalEasy).
        sessionStorage.setItem('vhp_planner_goal', JSON.stringify(easy ? { goal: 'maintain', easy: true } : { goal: chip.dataset.goal }));
      } catch (e) {
        /* private mode: the planner asks the goal itself */
      }
      const d = plannableDish(chip.closest('[data-vhp-recipe-body]')?.dataset);
      if (d) {
        likeDish(d);
        keepPick(d.productId);
      }
      return;
    }

    const trigger = target.closest('[data-vhp-plan-cta]');
    if (!trigger) return;
    const where = SOURCE[trigger.dataset.vhpPlanCta] ? trigger.dataset.vhpPlanCta : 'top';
    // Cook mode's card sits in its own dialog: it names its recipe (data-vhp-plan-dish = the body's product id).
    const dishId = trigger.dataset.vhpPlanDish || '';
    const dish =
      trigger.closest('[data-vhp-recipe-body]')?.dataset ||
      (dishId ? document.querySelector(`[data-vhp-recipe-body][data-product-id="${CSS.escape(dishId)}"]`)?.dataset : undefined);
    // The recipe's protein CTA (data-vhp-plan-direct) skips the explainer: the planner answers its question.
    if (!('vhpPlanDirect' in trigger.dataset) && open({ where, dish })) {
      event.preventDefault();
      return;
    }
    // Straight into the planner. The recipe CTA and card send no planner_cta_click of their own (data-track opens
    // the explainer), so the entry is set here; the top bar and side menu carry theirs. The calculator's "Meinen Tag
    // planen" counts apart when it sits on a swipe card (card_calc) or showed a remembered target (portion_line).
    if (DIRECT.has(where)) {
      const calc = trigger.closest('[data-vhp-calc]');
      let source = SOURCE[where];
      if (calc && calcWhere(calc) === 'card') source = 'card_calc';
      else if (calc?.dataset.remembered) source = 'portion_line';
      window.vhpTrack?.('planner_cta_click', { source });
      const d = plannableDish(dish || trigger.closest('[data-vhp-card-calc]')?.dataset);
      if (d) {
        likeDish(d);
        keepPick(d.productId);
      }
      // The recipe's other doors take this visit's calculator answers along, as its own button does; the story then
      // shows their portion of this dish (?src=portion) instead of the door's hook.
      if (!calc && where !== 'top' && !started() && handCalc() && trigger instanceof HTMLAnchorElement) {
        const url = new URL(trigger.href, location.href);
        url.searchParams.set('src', 'portion');
        trigger.href = url.pathname + url.search;
      }
    }
  });

  // ---------- "Und morgen?" after the method (docs/RECIPE_FUNNEL.md 3.2) ----------
  // Up to three similar dishes from the page's "Ähnliche Rezepte" row (snippets/vhp-related-recipes.liquid), plannable
  // ones, mains first. With a known day target each shows their portion (the swipe card's "¾ Portion für dich · 512
  // kcal"), else protein and time. Rows open the recipe. No row (the sheet has no related row): the week of dishes stays.
  // Painted whenever the card comes into view, so a portion calculated above it shows up.
  const fillT = (template, vars) => String(template || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
  const CHEVRON_SVG =
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  const paintNext = (card) => {
    const rows = card.querySelector('[data-vhp-next-rows]');
    if (!rows) return;
    const own = card.closest('[data-vhp-recipe-body]')?.dataset.productId || '';
    const pool = [...document.querySelectorAll('.recipe-related [data-vhp-recipe][data-id]')]
      .map((el) => el.dataset)
      .filter((d, i, all) => d.plannable === 'true' && d.id !== own && Number(d.kcal) > 0 && all.findIndex((x) => x.id === d.id) === i);
    const picks = [...pool.filter((d) => d.slot === 'main'), ...pool.filter((d) => d.slot !== 'main')].slice(0, 3);
    if (!picks.length) return;
    const day = targetDay();
    rows.replaceChildren(
      ...picks.map((d) => {
        const p = day ? portionOf({ kcal: d.kcal, protein: d.protein, slot: d.slot }, day) : null;
        let meta = '';
        if (p) {
          const amount = fillT(p.scale <= 1 ? card.dataset.tOne : card.dataset.tOther, { n: p.amount });
          meta = fillT(card.dataset.tYours, { amount, kcal: p.kcal });
        } else {
          meta = fillT(card.dataset.tMeta, { protein: Math.round(Number(d.protein) || 0), time: d.time || '' });
          if (!d.time) meta = meta.split(' · ')[0];
        }
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'vhp-next__row';
        a.href = d.href || '#';
        const face = d.poster || d.image;
        if (face) {
          const img = document.createElement('img');
          img.src = face;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 48;
          img.height = 48;
          a.append(img);
        }
        const copy = document.createElement('span');
        copy.className = 'vhp-next__copy';
        const title = document.createElement('span');
        title.className = 'vhp-next__title';
        title.textContent = d.title || '';
        const line = document.createElement('span');
        line.className = `vhp-next__meta${p ? ' is-yours' : ''}`;
        line.textContent = meta;
        copy.append(title, line);
        a.append(copy);
        a.insertAdjacentHTML('beforeend', CHEVRON_SVG);
        li.append(a);
        return li;
      })
    );
    rows.hidden = false;
    // 2026-11-01 (docs/RECIPE_CRO_ATTACK_PLAN.md Q2): the week strip stays; the rows are the "Oder einzeln" list.
    const alt = card.querySelector('[data-vhp-next-alt]');
    if (alt) alt.hidden = false;
  };
  const bindNext = () => {
    const cards = document.querySelectorAll('.vrp [data-vhp-next]');
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) {
      cards.forEach(paintNext);
      return;
    }
    const seen = new IntersectionObserver((entries) => entries.forEach((entry) => entry.isIntersecting && paintNext(entry.target)), {
      rootMargin: '200px 0px',
    });
    cards.forEach((card) => seen.observe(card));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindNext, { once: true });
  else bindNext();

  // ---------- cook mode's "Fertig" (docs/RECIPE_FUNNEL.md 3.1) ----------
  // For a recipe body with the end card (non-subscribers, plannable recipes; not in the planner) a small card for the
  // end screen of assets/vhp-cook.js, under the rating: "Morgen wieder so einfach?" straight into the planner
  // (entry cook_done, ?src=cooked). Its texts ride on the end card (data-t-*), so the preview-off note follows too.
  const cookCard = (body) => {
    // The end card, or the planner block in its place (data-vpb-end, docs/PLANNER_BLOCK.md): both carry the texts.
    const card = body?.querySelector('[data-vhp-next], [data-vpb-end]');
    if (!card || document.body.classList.contains('vhp-planner-page')) return null;
    const box = document.createElement('div');
    box.className = 'cook__next';
    const title = document.createElement('p');
    title.className = 'cook__next-title';
    title.textContent = card.dataset.tCookTitle || '';
    const text = document.createElement('p');
    text.className = 'cook__next-text';
    text.textContent = card.dataset.tCookText || '';
    const go = document.createElement('a');
    go.className = 'cook__next-cta';
    go.href = '/pages/meal-planner?src=cooked';
    go.dataset.vhpPlanCta = 'cooked';
    go.dataset.vhpPlanDirect = '';
    go.dataset.vhpPlanDish = body.dataset.productId || '';
    go.textContent = card.dataset.tCta || '';
    const note = document.createElement('p');
    note.className = 'cook__next-note';
    note.textContent = card.dataset.tNote || '';
    box.append(title, text, go, note);
    // The planner film's text-free loop above the title (docs/PLANNER_VIDEO.md 15): plays while half on screen
    // (assets/vhp-planner-block.js video[data-vpf-loop]); the card's own words stay the message.
    if (card.dataset.tFilm) {
      box.classList.add('is-film');
      const frame = document.createElement('span');
      frame.className = 'cook__next-film';
      frame.setAttribute('aria-hidden', 'true');
      const video = document.createElement('video');
      video.dataset.vpfLoop = '';
      video.dataset.src = card.dataset.tFilm;
      if (card.dataset.tFilmPoster) video.poster = card.dataset.tFilmPoster;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'none';
      frame.append(video);
      box.prepend(frame);
    }
    return box;
  };
  window.vhpPlanNext = { cookCard };
})();
